import React from "react";
import { SITE } from "@/data/site";

const WhatsAppButton = () => (
    <a
        href={SITE.whatsappUrlAppointment}
        target="_blank"
        rel="noreferrer"
        className="acd-whatsapp"
        aria-label="Falar no WhatsApp"
        data-testid="whatsapp-float"
    >
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.52 3.48A11.79 11.79 0 0 0 12.05 0C5.46 0 .1 5.36.1 11.95a11.9 11.9 0 0 0 1.6 5.97L0 24l6.24-1.64a11.94 11.94 0 0 0 5.81 1.48h.01c6.6 0 11.95-5.36 11.95-11.95a11.86 11.86 0 0 0-3.49-8.41zM12.06 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.7.97.99-3.6-.24-.37a9.86 9.86 0 0 1-1.5-5.26c0-5.46 4.44-9.9 9.91-9.9 2.65 0 5.14 1.03 7.01 2.9a9.85 9.85 0 0 1 2.9 7.02c0 5.46-4.44 9.9-9.91 9.9zm5.44-7.4c-.3-.15-1.76-.87-2.03-.97s-.47-.15-.67.15-.77.97-.94 1.17-.35.22-.65.07a8.13 8.13 0 0 1-2.39-1.47 8.98 8.98 0 0 1-1.65-2.05c-.17-.3 0-.46.13-.61.14-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.49.71.3 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z" />
        </svg>
    </a>
);

export default WhatsAppButton;
